/**
 * Clears prior DSC context in GTM before a new custom event (repo-wide pattern).
 * @see src/js/components/accounts/account-cancelation-flow.js
 * @see src/assets/prosperstack.js
 */
export const CLEAR_DSC_DATA_LAYER_EVENT = 'dl_custom_clear_dsc_data';

/**
 * Push a custom dataLayer event with a DSC payload (Google Tag Manager / GA4 pattern).
 * Fires {@link CLEAR_DSC_DATA_LAYER_EVENT} first so stale `DSC` does not leak between events.
 *
 * @param {string} eventName - e.g. 'dl_custom_sub_frequency_change'
 * @param {Record<string, unknown>} dsc - DSC object for the event
 * @param {{ clearDscFirst?: boolean }} [options] - Pass `{ clearDscFirst: false }` to skip the clear push when needed.
 */
export function pushDscDataLayerEvent(eventName, dsc, options = {}) {
  const { clearDscFirst = true } = options;
  window.dataLayer = window.dataLayer || [];
  if (clearDscFirst) {
    window.dataLayer.push({ event: CLEAR_DSC_DATA_LAYER_EVENT, DSC: undefined });
  }
  window.dataLayer.push({ event: eventName, DSC: dsc });
}
